import {
  Mapping,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMappingLabel,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { getLabelKeyFromMappingKey } from 'src/containers/ProjectDiagram/utils/mapping/createMappingLabel';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { removeRelationshipMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeRelationshipMapping';

export const removeMapping = (mapping: Mapping) => (model: Model) => {
  model.removeLinkData(mapping);

  const labelKey = getLabelKeyFromMappingKey(mapping.key);
  const labelData = model.nodeDataArray.find(
    (nodeData) => isMappingLabel(nodeData) && nodeData.key === labelKey
  );
  if (labelData) {
    model.removeNodeData(labelData);
    doMappingUpdated(mapping)(model);
  }

  const linkDataToRemove: RelationshipMapping[] = [];
  model.linkDataArray.forEach((linkData) => {
    if (
      isRelationshipMapping(linkData) &&
      (linkData.from === mapping.key || linkData.to === mapping.key)
    ) {
      linkDataToRemove.push(linkData);
    }
  });
  // do not mutate linkDataArray while iterating through linkDataArray
  linkDataToRemove.forEach((linkData) =>
    removeRelationshipMapping(linkData)(model)
  );
};
